function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';
import { d as defineCustomElement$5 } from './flex.js';
import { d as defineCustomElement$4 } from './icon.js';
import { d as defineCustomElement$3 } from './radio.js';
import { d as defineCustomElement$2 } from './text.js';
var RadioGroup = /*@__PURE__*/proxyCustomElement( /*#__PURE__*/function (_HTMLElement) {
  _inherits(RadioGroup, _HTMLElement);

  var _super = _createSuper(RadioGroup);

  function RadioGroup() {
    var _this;

    _classCallCheck(this, RadioGroup);

    _this = _super.call(this);

    _this.__registerHost();

    _this.skpRadioCheck = createEvent(_assertThisInitialized(_this), "skpRadioCheck", 7);
    _this.direction = 'column';
    _this.disabled = false;
    _this.gap = 3;
    _this.name = "radio-group-".concat(Math.ceil(Math.random() * Date.now()));
    _this.options = undefined;
    _this.size = undefined;
    _this.value = undefined;
    return _this;
  }

  _createClass(RadioGroup, [{
    key: "onSkpCheck",
    value: function onSkpCheck(e) {
      this.skpRadioCheck.emit(e.detail);
      this.value = e.detail;
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      var _a, _b;

      if (this.disabled) return;

      if (['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight'].includes(e.code)) {
        e.preventDefault();
        var currentRadio = e.target.parentElement;
        var values = this.options.filter(function (_ref) {
          var disabled = _ref.disabled;
          return !disabled;
        }).map(function (_ref2) {
          var value = _ref2.value;
          return value;
        });
        var currentIndex = values.findIndex(function (value) {
          return value === currentRadio.value;
        });
        var nextValue = e.code === 'ArrowDown' || e.code === 'ArrowRight' ? values[currentIndex + 1] || values[0] : values[currentIndex - 1] || values[values.length - 1];
        (_b = (_a = currentRadio.parentElement.querySelector("[value=\"".concat(nextValue, "\"]"))) === null || _a === void 0 ? void 0 : _a.querySelector('label')) === null || _b === void 0 ? void 0 : _b.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return h("skp-flex", {
        flexDirection: this.direction,
        justifyContent: 'flex-start',
        gap: this.gap,
        onKeyDown: this.handleKeyDown.bind(this)
      }, this.options.map(function (option) {
        return h("skp-radio", Object.assign({}, option, {
          checked: _this2.value === option.value,
          disabled: _this2.disabled || option.disabled,
          name: _this2.name,
          size: _this2.size || option.size
        }));
      }));
    }
  }]);

  return RadioGroup;
}(HTMLElement), [0, "skp-radio-group", {
  "direction": [1],
  "disabled": [4],
  "gap": [2],
  "name": [1],
  "options": [16],
  "size": [1],
  "value": [1025]
}, [[0, "skpCheck", "onSkpCheck"]]]);

function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }

  var components = ["skp-radio-group", "skp-flex", "skp-icon", "skp-radio", "skp-text"];
  components.forEach(function (tagName) {
    switch (tagName) {
      case "skp-radio-group":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, RadioGroup);
        }

        break;

      case "skp-flex":
        if (!customElements.get(tagName)) {
          defineCustomElement$5();
        }

        break;

      case "skp-icon":
        if (!customElements.get(tagName)) {
          defineCustomElement$4();
        }

        break;

      case "skp-radio":
        if (!customElements.get(tagName)) {
          defineCustomElement$3();
        }

        break;

      case "skp-text":
        if (!customElements.get(tagName)) {
          defineCustomElement$2();
        }

        break;
    }
  });
}

var SkpRadioGroup = RadioGroup;
var defineCustomElement = defineCustomElement$1;
export { SkpRadioGroup, defineCustomElement };